import { FormControl as Root, useFormControl } from './FormControl';
import { FormControlGroup as Group } from './FormControlGroup';
import { FormControlHelperText as HelperText, } from './FormControlHelperText';
import { FormControlLabel as Label } from './FormControlLabel';
const FormControl = {
    Group,
    HelperText,
    Label,
    Root,
};
export { FormControl, useFormControl, };
//# sourceMappingURL=index.js.map